import { FOUR_WEEKS_TO_DAYS, TWO_WEEKS_TO_DAYS } from '@moda/portal-stanchions';
import { ReturnPolicy } from '../../../generated/types';

type ReturnableReturnPolicy =
  | ReturnPolicy.full_refund
  | ReturnPolicy.full_refund_markdown
  | ReturnPolicy.full_refund_no_credit
  | ReturnPolicy.site_credit
  | ReturnPolicy.site_credit_markdown;

enum ReturnPolicyMethod {
  FullRefund = 'full refund',
  SiteCredit = 'site credit'
}

export const getReturnPolicy = (returnPolicy: ReturnableReturnPolicy) => {
  // TODO -- move this to api
  const getDaysNumber = (): typeof TWO_WEEKS_TO_DAYS | typeof FOUR_WEEKS_TO_DAYS | undefined => {
    if (
      [
        ReturnPolicy.full_refund_markdown,
        ReturnPolicy.full_refund_no_credit,
        ReturnPolicy.site_credit_markdown
      ].includes(returnPolicy)
    ) {
      return TWO_WEEKS_TO_DAYS;
    }

    if ([ReturnPolicy.full_refund, ReturnPolicy.site_credit].includes(returnPolicy)) {
      return FOUR_WEEKS_TO_DAYS;
    }
  };

  const getRefundMethod = (): ReturnPolicyMethod | undefined => {
    if (
      [
        ReturnPolicy.full_refund,
        ReturnPolicy.full_refund_markdown,
        ReturnPolicy.full_refund_no_credit
      ].includes(returnPolicy)
    ) {
      return ReturnPolicyMethod.FullRefund;
    }

    if ([ReturnPolicy.site_credit, ReturnPolicy.site_credit_markdown].includes(returnPolicy)) {
      return ReturnPolicyMethod.SiteCredit;
    }
  };

  return {
    returnDaysNumber: getDaysNumber(),
    refundMethod: getRefundMethod()
  };
};
